import { render, staticRenderFns } from "./CampaignBookmark.vue?vue&type=template&id=02d45a9d"
import script from "./CampaignBookmark.vue?vue&type=script&lang=js"
export * from "./CampaignBookmark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports